import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58e0f44b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-none d-sm-none d-md-none d-lg-block" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "d-block d-sm-block d-md-block d-lg-none" }
const _hoisted_4 = ["id", "disabled"]

import { QuizzSentence } from '@/types/Quizz'
import { computed } from 'vue'
import QuizzIllustrationCard from './QuizzIllustrationCard.vue'
import correctCircle from '@/assets/svg/correct-circle.svg'
import wrongCircle from '@/assets/svg/wrong-circle.svg'


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null,
    currentAnswerId: null,
    sentence: null,
    showFeedback: { type: Boolean }
  },
  emits: ['onDrop', 'onDragOver', 'on-click'],
  setup(__props: any, { emit }) {

const props = __props as {
  id: number
  currentAnswerId: number | null
  sentence: QuizzSentence
  showFeedback: boolean
}





const cardIcon = computed(() => {
  if (props.showFeedback && isCorrect.value) {
    return correctCircle
  } else if (props.showFeedback && isCorrect.value === false) {
    return wrongCircle
  } else {
    return ''
  }
})

function onClick(targetId: number) {
  emit('on-click', targetId)
}

function onDragOver(ev: Event) {
  emit('onDragOver', ev)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function onDrop(ev: any) {
  emit('onDrop', ev)
}

const answer = computed(() => {
  if (!props.currentAnswerId) {
    return null
  }

  return props.sentence.answers[props.currentAnswerId - 1]
})

const correctAnswerId = computed(
  () => props.sentence.correctAnswers[props.id - 1]
)

const isCorrect = computed(
  () => correctAnswerId.value === props.currentAnswerId
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("template", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(`quizz-illustration-placeholder placeholder-${props.id}`),
        id: `puzzle-step-placeholder-${props.id}`,
        onDrop: onDrop,
        onDragover: onDragOver
      }, [
        (_unref(answer) || props.showFeedback)
          ? (_openBlock(), _createBlock(QuizzIllustrationCard, {
              key: 0,
              class: _normalizeClass({
          'btn-choices-correct': props.showFeedback && _unref(isCorrect),
          'btn-choices-wrong ': props.showFeedback && !_unref(isCorrect),
        }),
              id: _unref(answer)?.id ?? 0,
              "is-draggable-element": true,
              answer: 
          props.showFeedback
            ? `quizz.questions.${props.sentence.id}.answers.${_unref(correctAnswerId)}`
            : _unref(answer)?.answer
        ,
              draggable: !props.showFeedback,
              icon: _unref(cardIcon)
            }, null, 8, ["class", "id", "answer", "draggable", "icon"]))
          : _createCommentVNode("", true)
      ], 42, _hoisted_2)
    ]),
    _createElementVNode("template", _hoisted_3, [
      _createElementVNode("button", {
        class: _normalizeClass(`quizz-illustration-placeholder placeholder-${props.id}`),
        id: `puzzle-step-placeholder-${props.id}`,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick(props.id))),
        disabled: props.showFeedback
      }, [
        (_unref(answer) || props.showFeedback)
          ? (_openBlock(), _createBlock(QuizzIllustrationCard, {
              key: 0,
              class: _normalizeClass({
          'btn-choices-correct': props.showFeedback && _unref(isCorrect),
          'btn-choices-wrong ': props.showFeedback && !_unref(isCorrect),
        }),
              id: _unref(answer)?.id ?? 0,
              "is-draggable-element": false,
              answer: 
          props.showFeedback
            ? `quizz.questions.${props.sentence.id}.answers.${_unref(correctAnswerId)}`
            : _unref(answer)?.answer
        ,
              disabled: props.showFeedback,
              icon: _unref(cardIcon)
            }, null, 8, ["class", "id", "answer", "disabled", "icon"]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_4)
    ])
  ], 64))
}
}

})